// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M15.7479 2.94711C16.5289 2.16607 17.7953 2.16607 18.5763 2.94711L21.0512 5.42199C21.8322 6.20304 21.8322 7.46937 21.0512 8.25042L16.4983 12.8031L15.0842 11.3889L16.5799 9.89322L14.105 7.41834L12.6092 8.91406L11.1951 7.49981L15.7479 2.94711ZM3.99991 2.58564L21.4141 19.9998L19.9999 21.4141L13.9435 15.3577L9.15772 20.1435L2.77797 21.2199L3.85442 14.8402L8.64023 10.0544L2.58569 3.99985L3.99991 2.58564ZM10.0544 11.4686L5.72027 15.8028L5.21793 18.78L8.19515 18.2776L12.5293 13.9435L10.0544 11.4686Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-edit-off-filled')
export default class EditOffFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'edit-off-filled',
    }
  }
}
